import type { FlightFeatureConfig } from '../../../types/insurances/FlightFeatureConfig';

export const flight: FlightFeatureConfig = {
    overview: {
        details: {
            showVariant: false,
            fallbackAssistancePhonesKey: null,
            fallbackAssistanceEmailsKey: null,
        },
    },
};
